import PropTypes from "prop-types";

import {
  Box,
  Tab,
  Tabs,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";

import "../styles.css";
import AccordionSummaryTitle from "../AccordionSummaryTitle";
// import PainelDadosGerais from "./Paineis/PainelDadosGerais";
import PanelNervosCranianos from "./Paineis/PainelNervosCranianos";
import PainelMotor from "./Paineis/PainelMotor";
import PainelSensibilidade from "./Paineis/PainelSensibilidade";
import handleProgressForm from "./progressForm";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ExameNeurologico({
  expanded,
  handleChangePanel,
  tabOnChange,
  tabValue,
  onSubmit,
  data,
  setData,
  pesoHabitual,
  simOuNaoOptions,
  statusCognitivoOptions,
  presenteAusenteOptions,
  reflexoNauseosoOptions,
  musculaturaFacialOptions,
  handleCheckedField,
  masseterOptions,
  linguaMovimentacaoOptions,
  linguaAtrofiaOptions,
  veloPalatinoOptions,
  fasciculacoesOndeOptions,
  tonusMuscularOptions,
  reflexoOptions,
  avaliacaoSegmentarOptions,
  disfuncaoAutonomicaOptions,
  handleDisfuncaoAutonomicaTipo,
}) {
  const progressForm = handleProgressForm(data);

  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "exameNeurologico"}
      onChange={handleChangePanel("exameNeurologico")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="exameNeurologico-content"
        id="exameNeurologico-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Exame neurológico"
          icon={<IconDocument style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            TabIndicatorProps={{
              style: {
                background: "#1E729F",
              },
            }}
            value={tabValue}
            onChange={tabOnChange}
            aria-label="center"
            sx={{
              fontFamily: "Nunito",
              fontWeight: 400,
              ".Mui-selected": {
                color: "#1E729F",
                fontWeight: "700 !important",
              },
            }}
          >
            {/* <Tab label="Dados gerais" {...a11yProps(0)} className="tabTitle" /> */}
            <Tab
              label="Nervos cranianos"
              {...a11yProps(0)}
              className="tabTitle"
            />
            <Tab label="Motor" {...a11yProps(1)} className="tabTitle" />
            <Tab label="Sensibilidade" {...a11yProps(2)} className="tabTitle" />
          </Tabs>
        </Box>
        {/* <CustomTabPanel value={tabValue} index={0}>
          <PainelDadosGerais
            handleChangePanel={handleChangePanel}
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            pesoHabitual={pesoHabitual}
            simOuNaoOptions={simOuNaoOptions}
            statusCognitivoOptions={statusCognitivoOptions}
          />
        </CustomTabPanel> */}
        <CustomTabPanel value={tabValue} index={0}>
          <PanelNervosCranianos
            handleChangePanel={handleChangePanel}
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            simOuNaoOptions={simOuNaoOptions}
            presenteAusenteOptions={presenteAusenteOptions}
            reflexoNauseosoOptions={reflexoNauseosoOptions}
            musculaturaFacialOptions={musculaturaFacialOptions}
            handleCheckedField={handleCheckedField}
            masseterOptions={masseterOptions}
            linguaMovimentacaoOptions={linguaMovimentacaoOptions}
            linguaAtrofiaOptions={linguaAtrofiaOptions}
            veloPalatinoOptions={veloPalatinoOptions}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <PainelMotor
            handleChangePanel={handleChangePanel}
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            simOuNaoOptions={simOuNaoOptions}
            presenteAusenteOptions={presenteAusenteOptions}
            fasciculacoesOndeOptions={fasciculacoesOndeOptions}
            handleCheckedField={handleCheckedField}
            tonusMuscularOptions={tonusMuscularOptions}
            reflexoOptions={reflexoOptions}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <PainelSensibilidade
            handleChangePanel={handleChangePanel}
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            simOuNaoOptions={simOuNaoOptions}
            avaliacaoSegmentarOptions={avaliacaoSegmentarOptions}
            disfuncaoAutonomicaOptions={disfuncaoAutonomicaOptions}
            handleCheckedField={handleCheckedField}
          />
        </CustomTabPanel>
      </AccordionDetails>
    </Accordion>
  );
}
